export default __webpack_public_path__ + "static/media/m3_element_blue.1ea51574.png";